import { keys } from './constants';
import { changeCurrentDevice } from './device-checker';

export const bm_eventNamespace = '.BMUI';
let resizeTimer;

/**
 * Provides an event name based on the string passed in and bm_eventNamespace constant.
 * @param {string} eventName
 * @returns {string} - Namespaced event name.
 */
export const getBMNamespaceEvent = (eventName) => {
  if (!eventName) return;
  return eventName.replace(/\s/g, bm_eventNamespace + ' ') + bm_eventNamespace;
};

// Resize event listener
window.addEventListener('resize', () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(changeCurrentDevice, 100);
});

// Event listener for body click and keydown
document.body.addEventListener('click', handleBodyEvent);
document.body.addEventListener('keydown', handleBodyEvent);

function handleBodyEvent(e) {
  if (e.type === 'keydown') {
    if (e.keyCode === keys.tab) {
      document.body.classList.add('tabPressed');
    }
  } else {
    if (!['INPUT', 'BUTTON', 'A'].includes(e.target.tagName)) {
      document.body.classList.remove('tabPressed');
    }
  }
}
